import {createFileRoute} from '@tanstack/react-router'

import privateRoute from '@/auth/middleware/privateRoute'

export const Route = createFileRoute('/_account/addresses/')({
  beforeLoad: ({context, location}) => {
    privateRoute(context.store, location.href)
  },
})
